import { SidebarProvider } from '@ui/components';
import { Topbar } from '@shared/components';
import { ssManager } from '@shared/utils';
import { ReactNode, FC } from 'react';

import { Navbar } from './navbar/navbar';
import { Header } from './header/header';

export const CompanyLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const defaultOpen = ssManager.flag('SIDEBAR_OPEN');

  return (
    <>
      <Topbar />
      <SidebarProvider className="!min-h-0 h-full" defaultOpen={defaultOpen}>
        <Navbar />
        <main className="flex flex-col px-6 py-8 w-full max-h-screen overflow-x-hidden bg-cover bg-[url('../images/background.svg')]">
          <Header />
          {children}
        </main>
      </SidebarProvider>
    </>
  );
};
